import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

function formatAgo(ts) {
  if (!ts) return '';
  const seconds = Math.floor((Date.now() - ts) / 1000);
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ago`;
}

class RefreshWidget extends React.Component {
  static defaultProps = {
    intervalMs: 180000,
    cooldownMs: 30000
  };

  constructor(props) {
    super(props);
    // lastUpdated is the self-tracked fallback when the parent passes no
    // lastFetchedAt prop — keeps the "Updated Xago" label live like the mock.
    this.state = { disabled: false, lastUpdated: Date.now() };
    this._intervalId = null;
    this._cooldownId = null;
    this._mounted = false;
  }

  componentDidMount() {
    this._mounted = true;
    const { intervalMs, onRefresh } = this.props;
    this._intervalId = setInterval(() => {
      if (!this._mounted) return;
      onRefresh();
      this.setState({ lastUpdated: Date.now() });
    }, intervalMs);
  }

  componentWillUnmount() {
    this._mounted = false;
    clearInterval(this._intervalId);
    if (this._cooldownId) clearTimeout(this._cooldownId);
  }

  handleClick = () => {
    const { onRefresh, cooldownMs } = this.props;
    onRefresh();
    this.setState({ disabled: true, lastUpdated: Date.now() });
    this._cooldownId = setTimeout(() => {
      if (this._mounted) this.setState({ disabled: false });
    }, cooldownMs);
  };

  render() {
    const { intervalMs, lastFetchedAt } = this.props;
    const { disabled, lastUpdated } = this.state;
    const intervalMinutes = Math.round(intervalMs / 60000);
    const ts = lastFetchedAt != null ? lastFetchedAt : lastUpdated;

    return (
      <div>
        <span>Live</span> <span>· Updated {formatAgo(ts)}</span>{' '}
        <span>· Auto every {intervalMinutes}m</span>
        <Button
          icon={<ReloadOutlined />}
          disabled={disabled}
          onClick={this.handleClick}
          aria-label="Refresh"
          title="Refresh"
          style={{ marginLeft: 8 }}
        />
      </div>
    );
  }
}

RefreshWidget.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  intervalMs: PropTypes.number,
  cooldownMs: PropTypes.number,
  lastFetchedAt: PropTypes.number
};

export default RefreshWidget;
